import { createFileRoute, redirect } from '@tanstack/react-router'
import { GoalsPage } from '../pages/GoalsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/goals' as any)({
    component: GoalsPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
